import PropTypes from 'prop-types';
import React from 'react';
import { last, startCase } from 'lodash';
import { t } from '../../../../modules/infra/i18n';

const parseRequirement = (requirement) => {
  if (requirement === 'company.verification.document') {
    return t('settings:bank_account_verification_error.business_registration');
  }
  const type = last(requirement.split('.'));
  switch (type) {
    case 'document':
      return t('settings:bank_account_verification_error.photo_id');
    default:
      return startCase(type);
  }
};


const BankAccountVerificationError = ({ err }) => (
  <p className="u-mb--"><strong>{t('settings:bank_account_verification_error.required')} {parseRequirement(err.requirement)}</strong> - {err.reason}</p>
);

BankAccountVerificationError.propTypes = {
  err: PropTypes.object.isRequired,
};

export default BankAccountVerificationError;
